import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Autocomplete } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIsMobileForHomePage } from '~/hooks/useIsMobileForHomePage';
import { useLocaleKeys } from '~/i18n';
import styles from '../GlobalBillingHub.module.scss';
import { billingHubHeaderTextsPath, getDefaultRelationshipId, getGroupedAgreementOptions, toAdHocOptions } from '../GlobalBillingHub.utils';
export const GetGlobalBillingHubHeaderTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            GlobalBillingHubHeaderTestIds: {
                Client: 'gbh-client',
                Relationship: 'gbh-relationship'
            }
        }
    });
export const GlobalBillingHubHeader = (param)=>{
    let { agreements, clientOptions, selectedClient, changeUrlState, groupedOptions, relationshipId } = param;
    var _relationshipOptions_find;
    const { t: headerTexts } = useLocaleKeys(billingHubHeaderTextsPath);
    const { t: gbhTexts } = useLocaleKeys('billing.globalHub');
    const { GlobalBillingHubHeaderTestIds } = useMemo(()=>GetGlobalBillingHubHeaderTID(), []);
    const isMobileDevice = useIsMobileForHomePage();
    const hasAdHoc = groupedOptions.adHocRelationships.length > 0;
    const hasAgreements = groupedOptions.agreements.length > 0;
    const relationshipOptions = useMemo(()=>[
            ...groupedOptions.agreements,
            ...toAdHocOptions(groupedOptions.adHocRelationships, headerTexts)
        ], [
        groupedOptions
    ]);
    const selectedRelationship = (_relationshipOptions_find = relationshipOptions.find((o)=>o.id === relationshipId)) !== null && _relationshipOptions_find !== void 0 ? _relationshipOptions_find : null;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.filters, {
            [styles.filtersMobile]: isMobileDevice
        }),
        children: [
            /*#__PURE__*/ _jsx(Autocomplete, {
                bi: {
                    name: 'client_search'
                },
                freeSolo: true,
                forcePopupIcon: true,
                className: cn(styles.autocomplete, {
                    [styles.autocompleteMobile]: isMobileDevice
                }),
                testId: GlobalBillingHubHeaderTestIds.Client(),
                options: clientOptions,
                value: selectedClient,
                getOptionLabel: (option)=>option.text,
                textFieldProps: {
                    label: gbhTexts.clientLabel(),
                    placeholder: gbhTexts.chooseClient()
                },
                onChange: (_, newOption)=>{
                    if (!newOption) {
                        changeUrlState({
                            clientId: '',
                            relationshipId: '',
                            selectedDate: ''
                        });
                    } else if (typeof newOption !== 'string' && !Array.isArray(newOption)) {
                        const newClientId = newOption.id;
                        if (newClientId === (selectedClient === null || selectedClient === void 0 ? void 0 : selectedClient.id)) return;
                        const grouped = getGroupedAgreementOptions(agreements, newClientId);
                        changeUrlState({
                            clientId: newClientId,
                            relationshipId: getDefaultRelationshipId([
                                ...grouped.agreements,
                                ...grouped.adHocRelationships
                            ]),
                            selectedDate: ''
                        });
                    }
                }
            }),
            relationshipId && relationshipOptions.length > 1 && /*#__PURE__*/ _jsx(Autocomplete, {
                bi: {
                    name: 'agreement_filter'
                },
                forcePopupIcon: true,
                className: cn(styles.autocomplete, {
                    [styles.autocompleteMobile]: isMobileDevice
                }),
                testId: GlobalBillingHubHeaderTestIds.Relationship(),
                options: relationshipOptions,
                value: selectedRelationship,
                getOptionLabel: (option)=>option.text,
                textFieldProps: {
                    label: headerTexts.agreementLabel(),
                    placeholder: headerTexts.noAgreements()
                },
                dividers: hasAgreements && hasAdHoc ? [
                    groupedOptions.agreements.length
                ] : undefined,
                onChange: (_, newOption)=>{
                    var _ref;
                    if (typeof newOption === 'string' || Array.isArray(newOption)) return;
                    const nextId = (_ref = newOption === null || newOption === void 0 ? void 0 : newOption.id) !== null && _ref !== void 0 ? _ref : '';
                    if (nextId === relationshipId) return;
                    changeUrlState({
                        relationshipId: nextId,
                        selectedDate: ''
                    });
                }
            })
        ]
    });
};
